import React, { useState, useEffect } from 'react';
import Pagination from './Pagination';

const AsignacionesTable = ({ asignaciones, loading, onFilterAsignaciones, onEliminarAsignacion }) => {
  const [searchAsignacion, setSearchAsignacion] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  useEffect(() => {
    onFilterAsignaciones(searchAsignacion);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchAsignacion]);
  
  const handleSearchAsignacionChange = (e) => {
    setSearchAsignacion(e.target.value);
    setCurrentPage(1); // Resetear a primera página al buscar
  };
  
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(1); // Resetear a primera página
  };
  
  // Lógica de paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = asignaciones.slice(indexOfFirstItem, indexOfLastItem);
  
  const totalPages = Math.ceil(asignaciones.length / itemsPerPage);
  
  return (
    <div className="space-y-4">
      <div className="flex flex-col space-y-2 md:flex-row md:items-center md:space-y-0">
        <div className="flex-1">
          <label htmlFor="buscar_asignacion" className="mb-2 block text-xs font-semibold uppercase tracking-[0.15em] text-slate-600">
            Buscar asignación
          </label>
          <input
            id="buscar_asignacion"
            type="text"
            placeholder="Nombre del cliente o aval"
            value={searchAsignacion}
            onChange={handleSearchAsignacionChange}
            className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 transition focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200"
          />
        </div>
        <div className="md:ml-4">
          <label htmlFor="items_per_page" className="mb-2 block text-xs font-semibold uppercase tracking-[0.15em] text-slate-600">
            Registros por página
          </label>
          <select 
            id="items_per_page"
            value={itemsPerPage} 
            onChange={handleItemsPerPageChange}
            className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 transition focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200 md:w-auto"
          >
            <option value="5">5 por página</option>
            <option value="10">10 por página</option>
            <option value="20">20 por página</option>
            <option value="50">50 por página</option>
          </select>
        </div>
      </div>
      
      {loading ? (
        <div className="rounded-xl border border-slate-200 bg-slate-50 py-6 text-center text-sm text-slate-600">
          Cargando asignaciones...
        </div>
      ) : asignaciones.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 bg-slate-50 py-8 text-center text-sm text-slate-500">
          {searchAsignacion ? 'No se encontraron resultados para la búsqueda' : 'No hay asignaciones registradas'}
        </div>
      ) : (
        <>
          <div className="overflow-x-auto rounded-xl border border-slate-200">
            <table className="min-w-full divide-y divide-slate-200">
              <thead className="bg-slate-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-[0.1em] text-slate-600">Cliente</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-[0.1em] text-slate-600">Aval</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-[0.1em] text-slate-600">Fecha de asignación</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-[0.1em] text-slate-600">Acciones</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 bg-white">
                {currentItems.map((asignacion) => (
                  <tr key={asignacion.id} className="hover:bg-slate-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                      {asignacion.cliente ? asignacion.cliente.nombreCompleto : 'Cliente no encontrado'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                      {asignacion.aval ? asignacion.aval.nombreCompleto : 'Aval no encontrado'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600">
                      {new Date(asignacion.created_at).toLocaleDateString()}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <button
                        onClick={() => onEliminarAsignacion(asignacion.id)}
                        className="rounded-lg bg-red-50 px-3 py-1.5 text-xs font-semibold text-red-700 transition hover:bg-red-100"
                      >
                        Eliminar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          <Pagination 
            currentPage={currentPage}
            totalPages={totalPages}
            itemsPerPage={itemsPerPage}
            totalItems={asignaciones.length}
            indexOfFirstItem={indexOfFirstItem}
            indexOfLastItem={indexOfLastItem}
            onPageChange={setCurrentPage}
          />
        </>
      )}
    </div>
  );
};

export default AsignacionesTable;
